import React, {useState, useEffect} from 'react';
import Button from '../../components/button/button_v2';
import GenericUpper from '../../components/generic-upper';
import logomini from '../../assets/logo-mini.png';
import logobling from '../../assets/logos/bling.png';
import logotiny from '../../assets/logos/tiny.png';
import logoomie from '../../assets/logos/omie.png';
import logocontaazul from '../../assets/logos/contaazul.png';
import InputV2 from '../../components/input/input_v2';
import List from '../../components/list';
import SelectV2 from '../../components/select/select_v2';
import api from '../../services/api';
import { BackLink, CardTitle, CardTop, Container, FrameworkCard, Grid, LogoBox, StepHeader, Tag, Tags, Text, Title } from './styles';
import { isTotvs } from '../../services/globalFunctions';
import { descricaoUrlPorFuncao } from '../../services/descricaoUrlIntegracao';


const AddIntegracao = ({ ...props }) => {
    const [functions, setFunctions] = useState([]);
    const [func, setFunc] = useState([]);
    const [url, setUrl] = useState('');
    const [headers, setHeaders] = useState([]);

    const [showFrameworks, setShowFrameworks] = useState(true);
    const [frameworks, setFrameworks] = useState([]);
    const [selectedFramework, setSelectedFramework] = useState(0);
    const [isProtheusPlan, setIsProtheusPlan] = useState(false);

    const getIntegrationFunctions = async () => {
        try {
            const response = await api.get('/integracao/not/functions');

            if (response) {
                setFunctions(response.data.data);
            }
        } catch (error) {
            
        }
    }

    const changeFunc = (e) => {
        setFunc(e);
    }

    const changeUrl = (value) => {
        if (value !== url) {
            setUrl(value);
        }
    }

    const changeHeaders = (value) => {
        let h = headers;

        h = [ ...h, value];

        setHeaders(h);
    }

    const save = () => {
        const payload = {
            url: url,
            function_id: func.value,
            header: headers,
            framework_id: selectedFramework
        }
        props.save(payload);
    }

    const getFrameworks = async () => {
        try {
            const response = await api.get('/integracao/frameworks');

            if (response) {
                console.log(response.data)
                const user = JSON.parse(localStorage.getItem('@userinfo') || '{}');
                const isProt = isTotvs();
                const data = Array.isArray(response.data.data) ? response.data.data : [];
                const filtered = isProt ? data.filter(f => f.framework === 'AgroReceita') : data;
                setFrameworks(filtered);

                if (isProt && filtered.length === 1) {
                    setShowFrameworks(false);
                    setSelectedFramework(filtered[0].id);
                } else if (props.preselectFramework) {
                    const preselected = filtered.find(f => f.framework === props.preselectFramework);

                    if (preselected) {
                        setShowFrameworks(false);
                        setSelectedFramework(preselected.id);
                    }
                }
            }
        } catch (error) {
        }
    }

    const selectFramework = (framework) => {
        setShowFrameworks(false);
        setSelectedFramework(framework.id);
    }

    const voltarFrameworks = () => {
        setShowFrameworks(true);
    }

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('@userinfo') || '{}');
        const planName = user?.contrato?.agro_plan_config?.nome_plano || '';
        setIsProtheusPlan(typeof planName === 'string' && planName.toUpperCase().includes('PROTHEUS'));
        getIntegrationFunctions();
        getFrameworks();
    }, []);

    return (
        <>
            {showFrameworks ? (
                <>
                    {props.onCancel && (
                        <StepHeader>
                            <BackLink onClick={() => props.onCancel()}>‹ Voltar</BackLink>
                        </StepHeader>
                    )}

                    <Title>Integrar o AgroReceita</Title>

                    <Text>Selecione a ferramenta que melhor te atenda e faça suas automatizações.</Text>

                    <Grid style={{ marginTop: '24px' }}>
                        {frameworks.map((f) => (
                            <FrameworkCard key={f.id} onClick={() => selectFramework(f)}>
                                <CardTop>
                                    <LogoBox>
                                        {f.framework === 'AgroReceita' ? (
                                            <img src={logomini} width='34px' alt='Logo Agroreceita' />
                                        ) : f.framework === 'Bling' ? (
                                            <img src={logobling} width='34px' alt='Logo Bling' />
                                        ) : f.framework === 'Tiny' ? (
                                            <img src={logotiny} width='34px' alt='Logo Tiny' />
                                        ) : f.framework === 'Omie' ? (
                                            <img src={logoomie} width='34px' alt='Logo Omie' />
                                        ) : f.framework === 'Conta Azul' ? (
                                            <img src={logocontaazul} width='34px' alt='Logo Conta Azul' />
                                        ) : null}
                                    </LogoBox>
                                    <Tags>
                                        {f.integration_type.id === 2 ? (
                                            <Tag variant="pluga">Via Pluga</Tag>
                                        ) : (
                                            <Tag variant="nativa">{f.integration_type.type}</Tag>
                                        )}
                                    </Tags>
                                </CardTop>
                                <CardTitle>{f.framework}</CardTitle>
                            </FrameworkCard>
                        ))}
                    </Grid>
                </>
            ) : (
                <Container>
                    {!isProtheusPlan && (
                        <StepHeader>
                            <BackLink onClick={() => voltarFrameworks()}>‹ Voltar</BackLink>
                        </StepHeader>
                    )}

                    <SelectV2
                        name="function"
                        className="func"
                        label="Integração"
                        id="func"
                        value={func.value || func}
                        onChange={e => changeFunc(e)}
                        options={functions}
                        selectUniqueOption={true}
                    />

                    <InputV2
                        id="url_id"
                        name="url"
                        label='URL'
                        legenda={descricaoUrlPorFuncao(func.label)}
                        value={url}
                        onChange={(e) => changeUrl(e)}
                    />

                    <List 
                        values={headers}
                        onChange={(e) => changeHeaders(e)}
                        id={props.functionId}
                    />

                    <div 
                        className="button" 
                        style={{ 
                            width: '100%', 
                            display: 'flex', 
                            flexDirection: 'row', 
                            justifyContent: 'center', 
                            marginTop: '40px', 
                            marginBottom: '60px' 
                        }}>

                        <Button 
                            width='296px'
                            height='50px'
                            value='SALVAR'
                            outline={false}
                            disabled={false}
                            onClick={() => save()}
                        />
                    </div>
                </Container>
            )}

        </>
    )
}

export default AddIntegracao;